import api from "@/core/api";

export const messageRead = () => api.query(`/messages`);
export const messageDelete = (id: string) => api.query(`/messages/${id}`, { method: "delete" });
export const messageSend = (recipient: string, message: string, route?: string) => 
	api.query(`/messages`, { 
		method: "post", 
		data: { recipient, message, route } 
	});
export const messageMarkAsRead = () => api.query(`/messages/read`, { method: "post" });